import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gfu-heading__wrapper _mb-3" }
const _hoisted_2 = {
  class: "gfu-list-info _fc",
  "data-qa": "begin-order-item-list-header"
}
const _hoisted_3 = { class: "gfu-list-info__left _mb-1 _flexaicntr" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "gfu-heading__thumb" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  class: "gfu-heading gfu-heading--text _tc--dark",
  "data-qa": "create-order:ProjectName"
}
const _hoisted_9 = { "format-key": "0" }
const _hoisted_10 = { "format-key": "1" }
const _hoisted_11 = {
  key: 0,
  "data-qa": "pledge-id"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: $props.projectUrl,
          class: "gfu-heading__thumb-wrapper"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: $props.thumbUrl,
              alt: $props.project.name
            }, null, 8 /* PROPS */, _hoisted_6)
          ])
        ], 8 /* PROPS */, _hoisted_4),
        _createElementVNode("div", null, [
          _createElementVNode("a", { href: $props.projectUrl }, [
            _createElementVNode("h2", _hoisted_8, [
              _createVNode(_component_localize, {
                resource: _ctx.Resources.Checkout.CheckoutHeaderProjectByCreatorTitle
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_9, _toDisplayString($options.projectName), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_10, _toDisplayString($options.projectCreatorName), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["resource"])
            ])
          ], 8 /* PROPS */, _hoisted_7),
          ($options.shouldDisplayPledgeID)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($options.pledgeIdentificationCopy), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ]))
}